import { Input } from '@verlo/shared/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@verlo/shared/components/ui/select';
import { UNITS, caseOf, parseUnit } from '../../lib/units';

// The unit a stock item is counted in (Back office sweep, Oct 2026): picked, not typed. A
// case asks how many are in it. An item set up before this keeps its own word as a choice
// until someone picks another.
export default function UnitField({ value, onChange, testId = 'stock-item-unit' }) {
  const u = parseUnit(value);
  const legacy = u.base && !UNITS.includes(u.base) ? u.base : null;
  return (
    <div className="flex items-center gap-2">
      <Select value={u.base || ''} onValueChange={(b) => onChange(b === 'case' ? caseOf(u.of || 12) : b)}>
        <SelectTrigger className="w-32" data-testid={testId}><SelectValue placeholder="Pick one" /></SelectTrigger>
        <SelectContent>
          {UNITS.map((x) => <SelectItem key={x} value={x}>{x === 'case' ? 'case of…' : x}</SelectItem>)}
          {legacy && <SelectItem value={legacy}>{legacy}</SelectItem>}
        </SelectContent>
      </Select>
      {u.base === 'case' && (
        <label className="flex items-center gap-2 text-[13px] text-ink-soft">of
          <Input type="number" min="1" step="1" value={u.of || ''} onChange={(e) => onChange(caseOf(Math.max(1, parseInt(e.target.value, 10) || 1)))}
            className="w-20 font-mono tabular-nums" aria-label="How many in a case" data-testid={`${testId}-case`} />
        </label>
      )}
    </div>
  );
}
